import {
  ExploreRoot,
  ExploreContainer,
  Title,
  LearnMoreContainer,
  RecipeCopy,
  BagImageWrapper,
  ButtonWrapper,
  Row,
} from './Explore.styles'
import { useTranslation } from 'hooks/useTranslation'
import { Text } from 'components/Text'
import { Button } from 'components/Button'
import Image, { StaticImageData } from 'next/image'
import Link from 'next/link'
import { FreezeDriedProteins } from 'models/Pet'

type ExploreProps = {
  recipe: FreezeDriedProteins
  image: StaticImageData
}

export const Explore = ({recipe, image}: ExploreProps) => {
  const { t } = useTranslation()

  return (
    <ExploreRoot>
      <ExploreContainer>
        <Title>{t(`recipes:freeze-dried.${recipe}.related-products.title`)}</Title>
        <LearnMoreContainer className="d-only">
          <BagImageWrapper>
            <Image
              src={image}
              layout='fill'
              alt={t(`recipes:freeze-dried.${recipe}.related-products.product.image`)}
            />
          </BagImageWrapper>
          <RecipeCopy>
            <Text size={{ '@initial': 'h5', '@bp2': 'h3' }}>
              {t(`recipes:freeze-dried.${recipe}.related-products.product.name`)}
            </Text>
            <Text>
              {t(`recipes:freeze-dried.${recipe}.related-products.product.description`)}
            </Text>
            <Link href={`/recipes/freeze-dried-raw-${recipe === FreezeDriedProteins.CHICKEN ? 'beef' : 'chicken'}`}>
              <Button variant="secondaryAlt">
                {t(`recipes:freeze-dried.${recipe}.related-products.product.cta`)}
              </Button>
            </Link>
          </RecipeCopy>
        </LearnMoreContainer>
        <LearnMoreContainer className="m-only">
          <Row>
            <BagImageWrapper>
              <Image
                src={image}
                alt={t(`recipes:freeze-dried.${recipe}.related-products.product.image`)}
              />
            </BagImageWrapper>
            <RecipeCopy>
              <Text size={{ '@initial': 'h5', '@bp2': 'h3' }}>
                {t(`recipes:freeze-dried.${recipe}.related-products.product.name`)}
              </Text>
              <Text size={{'@initial': 'caption', '@bp2': 'body'}}>
                {t(`recipes:freeze-dried.${recipe}.related-products.product.description`)}
              </Text>
            </RecipeCopy>
          </Row>
          <ButtonWrapper>
             <Link href={`/recipes/freeze-dried-raw-${recipe === FreezeDriedProteins.CHICKEN ? 'beef' : 'chicken'}`}>
              <Button fullWidth variant="secondaryAlt">
                {t(`recipes:freeze-dried.${recipe}.related-products.product.cta`)}
              </Button>
            </Link>
          </ButtonWrapper>
        </LearnMoreContainer>
      </ExploreContainer>
    </ExploreRoot>
  )
}

Explore.displayName = 'Explore'
